import React from "react";

export default function Form__separator() {
  return (
    <div className="Form__separator">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="25"
        fill="none"
      >
        <path
          fill="#fff"
          d="m9.4 24.65.67-7.5-6.22 4.34-3.4-5.96 6.8-3.15-6.8-3.15 3.4-5.96 6.22 4.34L9.4.11h6.81l-.68 7.5 6.22-4.34 3.41 5.96-6.8 3.15 6.8 3.15-3.4 5.96-6.23-4.34.68 7.5H9.4Z"
        />
      </svg>
    </div>
  );
}
